import { AnimatePresence, motion } from 'framer-motion'
import { CheckCircle } from 'lucide-react'
import '../css/Toast.css'

const Toast = ({ message, visible }) => {
	return (
		<AnimatePresence>
			{visible && (
				<motion.div
					className='toast'
					initial={{ opacity: 0, y: 40, scale: 0.95 }}
					animate={{ opacity: 1, y: 0, scale: 1 }}
					exit={{ opacity: 0, y: 40, scale: 0.95 }}
					transition={{ duration: 0.3, ease: 'easeOut' }}
				>
					<CheckCircle size={20} className='toast-icon' />
					<span className='toast-message'>{message}</span>
				</motion.div>
			)}
		</AnimatePresence>
	)
}

export default Toast
